<template>
    <div class="disease-card">
        <img
            :src="iconPath"
            :alt="disease.name"
            class="disease-icon"
        />
        <div
            class="disease-name"
        >
            {{disease.name}}
        </div>
        <div
            class="warningLevel"
            :class="warning"
        >
            {{getDiseaseStatusText}}
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            disease: {
                type: Object,
                required: true
            },
            diseaseID: {
                type: Number,
                required: true
            }
        },
        computed: {
            warning() {
                if(this.disease.index < 0) {
                    return 'not-available'
                }
                else if(this.disease.index > 1)
                    return 'warning'
                return ''
            },
            iconPath() {
                switch(this.disease.name) {
                    case '당뇨병': return require('@/assets/images/renew/ico-diabetes-90-x-90.svg')
                    case '간암': return require('@/assets/images/renew/ico-liver-cancer-90-x-90.svg')
                    case '대장암': return require('@/assets/images/renew/ico-colon-cancer-90-x-90.svg')
                    case '위암': return require('@/assets/images/renew/ico-gastric-cancer-90-x-90.svg')
                    case '폐암': return require('@/assets/images/renew/ico-lung-cancer-90-x-90.svg')
                    case '전립선암': return require('@/assets/images/renew/ico-prostate-cancer-90-x-90.svg')
                    case '유방암': return require('@/assets/images/renew/ico-breast-cancer-90-x-90.svg')
                    case '치매': return require('@/assets/images/renew/ico-dementia-90-x-90.svg')
                    case '심장질환': return require('@/assets/images/renew/ico-heart-90-x-90.svg')
                    case '뇌졸중': return require('@/assets/images/renew/ico-stroke-90-x-90.svg')
                }
            },
            getDiseaseStatusText() {
                if(this.disease.index < 0) {
                    return '-'
                }
                else if(this.disease.index <= 1) {
                    return '보통'
                }
                return '주의'
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
<style scoped>
    .diesease-card {
        text-align: center;
    }
    .disease-icon {
        width: 90px;
        height: 90px;
    }
    .disease-name {
        font-family: "NanumSquare", sans-serif;
        font-size: 18px;
        font-weight: 700;
        color: #193263;
        text-align: center;
    }
    .warningLevel {
        display: inline-block;
        color: white;
        background-color: #00baff;
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 14px;
        padding: 2px 14px;
        border-radius: 4px;
        text-align: center;
        vertical-align: middle;
    }
    .not-available {
        color: white;
        background-color: gray;
        width: 50px;
    }
    .warning {
        color: white;
        background-color: #ea5858;
    }

</style>
